module.exports = __webpack_public_path__ + "static/media/filter-settings.cbdb4a3a.svg";